import { AlertCircle } from "lucide-react";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function InvitationRetryCard({
  onRetry,
  isRetrying,
}: {
  onRetry: () => void;
  isRetrying: boolean;
}) {
  return (
    <>
      <CardHeader className="items-center text-center">
        <div className="rounded-full bg-red-100 p-3 mb-2">
          <AlertCircle className="h-6 w-6 text-red-600" />
        </div>
        <CardTitle className="text-xl">Couldn&apos;t load invitation</CardTitle>
        <CardDescription>
          Check your connection and try again. Your invitation link may still be
          valid.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button className="w-full" onClick={onRetry} disabled={isRetrying}>
          {isRetrying ? "Trying again…" : "Try again"}
        </Button>
      </CardContent>
    </>
  );
}
